import React, { createContext, useState, useCallback } from 'react';
import Toast from '../components/Toast';

export const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
    const [toastMessage, setToastMessage] = useState('');

    const showToast = useCallback((message) => {
        setToastMessage(message);
    }, []);

    const hideToast = useCallback(() => {
        setToastMessage('');
    }, []);

    return (
        <ToastContext.Provider value={{ showToast }}>
            {children}
            {toastMessage && (
                <Toast message={toastMessage} onClose={hideToast} />
            )}
        </ToastContext.Provider>
    );
};